// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__formItem___bQMTF {
}

.styles__formItemMono___uivLx {
}

.styles__label___O0uFB {
}

.styles__mono___GA4GE {
}
`, "",{"version":3,"sources":["webpack://./universal/components/SSNResetForm/styles.css"],"names":[],"mappings":"AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.mono {\n  composes: mono from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"formItem": `styles__formItem___bQMTF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItem"]}`,
	"formItemMono": `styles__formItemMono___uivLx ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemMono"]}`,
	"label": `styles__label___O0uFB ${___CSS_LOADER_ICSS_IMPORT_0___.locals["label"]}`,
	"mono": `styles__mono___GA4GE ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mono"]}`
};
export default ___CSS_LOADER_EXPORT___;
